import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import React, { type FC } from 'react';
import { TextButton } from 'wix-ui-tpa/cssVars';
import { useAddVisibilityClass } from '../../../../../hooks/useAddVisibilityClass';
import settingsParams from '../../../../../settingsParams';
import { classes, st } from './MoreInfoButton.st.css';
import { DataHooks } from './consts';

export interface MoreInfoButtonProps {
  onClick: () => void;
  url: string;
}

export const MoreInfoButton: FC<MoreInfoButtonProps> = ({ onClick, url }) => {
  const { isMobile } = useEnvironment();
  const { experiments } = useExperiments();
  const settings = useSettings();
  const { addVisibilityClass } = useAddVisibilityClass();
  const showDefaultValue = experiments.enabled(
    'specs.bookings.showDefaultValue',
  );

  return (
    <TextButton
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
      className={addVisibilityClass(
        st(classes.root, { isMobile }),
        classes.moreInfoButtonVisibility,
        'isMoreInfoButtonVisible',
      )}
      data-hook={DataHooks.ROOT}
      as="a"
      href={url}
    >
      {showDefaultValue
        ? settings.get(settingsParams.moreInfoButtonText) ||
          settings.getDefaultValue(settingsParams.moreInfoButtonText)
        : settings.get(settingsParams.moreInfoButtonText)}
    </TextButton>
  );
};
